export default __webpack_public_path__ + "5a0c697021ac1887382a4fcb83767325.png";